interface PPConfig {
  ecomProxyEndpoint?: string;
  coreEmbeddedEndpoint?: string;
  storeId?: string;
  clientId?: string;
}

function getRuntimeConfig(): PPConfig {
  return (window as any).__PP_CONFIG__ || {};
}

export function getEcomProxyEndpoint(): string {
  return getRuntimeConfig().ecomProxyEndpoint || LOCAL_ENV.ecomProxyEndpoint;
}

export function getCoreEmbeddedEndpoint(): string {
  return getRuntimeConfig().coreEmbeddedEndpoint || LOCAL_ENV.coreEmbeddedEndpoint;
}

export function getStoreConfig(): { storeId?: string; clientId?: string } {
  const config = getRuntimeConfig();
  return {
    storeId: config.storeId,
    clientId: config.clientId,
  };
}
